import { css } from '@lyearn/style';

export const mobileTabsStyles = css`
  .MuiTabs-flexContainer {
    display: flex !important;
    justify-content: space-between !important;
    width: 100% !important;
    max-width: 300px !important;
    margin: 0 auto !important;
    max-height: 44px !important;
  }

  .MuiTabs-root {
    width: 100% !important;
  }

  .MuiButtonBase-root {
    flex: 0 1 auto !important;
    min-width: 120px !important;
  }

  .MuiTabs-indicator {
    min-width: 145px !important;
    background-color: var(--interactive-primary) !important;
    height: 2px !important;
    margin-left: -40px !important;
  }

  .MuiTab-root {
    min-width: unset !important;
    padding: 12px 16px !important;
  }
`;
